// src/components/coins/CornerCoins.js
//
// The signed-in user's coins in the top-right corner, for full-screen pages
// that have no toolbar (games, the treasure map). Students and educators.
// Live: it ticks up the moment coins are earned.

import React from "react";
import { getAuth } from "firebase/auth";
import CoinCounter from "./CoinCounter";
import "./coins.css";

const CornerCoins = ({ className = "" }) => {
  if (!getAuth().currentUser) return null;
  return (
    <div className={`sbl-corner-coins ${className}`}>
      <CoinCounter size="sm" />
    </div>
  );
};

export default CornerCoins;
